module.exports = __webpack_public_path__ + "static/media/avatar-52-px-copia-3.0cc9f7f5.svg";